import React from 'react';
// import { AppWrap, MotionWrap } from '../../wrapper';

function AllSkills() {
    const skills = [
        {
            key: 'Languages',
            values: ['HTML', 'CSS', 'JavaScript', 'Python', 'PHP'], 
        },
        {
            key: 'Frameworks',
            values: ['React JS', 'Gatsby', 'Next JS', 'Express JS'], 
        },
        {
            key: 'Tools',
            values:  ['Node JS', 'MongoDB', 'MySQL', 'GraphQl', 'Git'], 
        },
        {
            key: 'Methodologies',
            values: ['Responsive web design', 'OOP', 'Functional Programing', 'Agile Development'], 
        },
       
    ]

  return (
    <div 
    style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', alignItems: 'flex-start', flexWrap: 'wrap'}}
    // className='all-skill-container'
    >
        {
            skills.map(item => {
                return (
                    <div key={item.key} style={{padding: '50px', borderRadius: '5px' }}>
                        <h2>{item.key}</h2>
                        <ul style={{display: 'flex', flexDirection: 'column' , justifyContent: 'space-around', gap: '10px', marginTop: '24px'}}>
                            {
                                item.values.map((el, idx) => {
                                    return (
                                        <li key={idx} style={{listStyle: 'none', backgroundColor: 'var(--primary-color)', textAlign: 'center', padding: '10px', border: '2px solid var(--accent-color)', borderRadius: '5px'}}>{el}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                )
            })
        }
        {/* <div>
            <h2></h2>
            <ul>
                <li></li>
            </ul>
        </div> */}
       
    </div>
  )
}

// export default AppWrap(
//     MotionWrap(AllSkills, 'app__works' ),
//      'work',
//      'app__primarybg'
//      );

export default AllSkills;
